<template>
  <div class="header">
    <div class="timebox">
      <div class="time1">{{ timeFormate() }}</div>
      <div class="time2">{{ state.nowTime }}</div>
    </div>
    <div class="headerTitle">{{ localTitle }}</div>
    <!-- <div class="leftMenuBox">
            <el-upload ref="upload" :before-upload="upload" :show-file-list="false" accept=".xlsx,.xls"
                style=" display: inline-flex;">
                <div class="leftMenuBt"> 导入文档 </div>
            </el-upload>
        </div> -->
    <div class="weatherBox">
      <img src="./home/assets/weather.png" alt="" class="weatherImg" />
      <span class="weather">多云</span>
      <span class="temperature">28℃</span>
    </div>
  </div>
</template>

<script setup>
import "@/components/style.less";
import { ref, reactive, computed, onMounted, onUnmounted } from "vue";

const state = reactive({
  time: { hour: "", minitus: "", seconds: "", weekday: "" },
  weekAll: [
    "星期日",
    "星期一",
    "星期二",
    "星期三",
    "星期四",
    "星期五",
    "星期六",
  ],
  nowTime: "",
});
// const { time, weekAll, nowTime } = state

// 将父组件传递的props声明为参数
const props = defineProps({ title: String });
// 使用ref将props中的数据声明为响应式数据
const localTitle = ref(props.title);

// 在setup中计算一个衍生的响应式数据
const computedMessage = computed(() => "Computed: " + localMessage.value);
const doubleCount = computed(() => state.count * 2);

const upload = (file) => {};

onMounted(() => {
  dateTime();
});

onUnmounted(() => {
  // console.log('Component unmounted');
});

// 时间开始
const dateTime = () => {
  timeFormate();
  setTimeout(() => {
    dateTime();
  }, 1000);
};
const getIncrease = (num, digit) => {
  var increase = "";
  for (var i = 0; i < digit; i++) {
    increase += "0";
  }
  return (increase + num).slice(-digit);
};
const timeFormate = () => {
  const newtime = new Date();
  state.time.hour = getIncrease(newtime.getHours(), 2);
  state.time.minitus = getIncrease(newtime.getMinutes(), 2);
  state.time.seconds = getIncrease(newtime.getSeconds(), 2);
  state.time.weekday = state.weekAll[newtime.getDay()];
  state.nowTime =
    getIncrease(newtime.getFullYear(), 4) +
    "年" +
    getIncrease(newtime.getMonth() + 1, 2) +
    "月" +
    getIncrease(newtime.getDate(), 2) +
    "日" +
    " " +
    state.weekAll[newtime.getDay()];
  // `${time.hour}:${time.minitus}:${time.seconds}`
  return `${state.time.hour}:${state.time.minitus}:${state.time.seconds}`;
};
// 时间结束
</script>

<style scoped>
/* 这里可以添加组件的样式 */
/* @import "@/components/style.less"; */
</style>
